module.exports = {"searchSection":{"title":"Gästeliste durchsuchen","searchInputPlaceholder":"Vorname, Nachname, Telefon...","clearButton":"Löschen"},"resultSection":{"title":"Meine Gästeliste","table":{"firstnameCol":"Vorname","lastnameCol":"Nachname","phoneCol":"Telefon","removeFromAction":"Von Gästeliste entfernen"}},"meta":"Gästeliste"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/guestlist.json
// module id = PXX7
// module chunks = 1